(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[603],{

/***/ 9788:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/offer-tag.f54e60b9.svg","height":37,"width":76});

/***/ }),

/***/ 56940:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/questions-hero.80e9ab30.svg","height":288,"width":805});

/***/ }),

/***/ 51413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _image_url_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36175);


var getImageAttributes = function(param) {
    var imageObject = param.imageObject, height = param.height, width = param.width;
    var image = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("image", imageObject);
    if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("asset", image)) {
        return null;
    }
    var caption = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)("", "caption", imageObject);
    return {
        alt: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(caption) ? "" : caption,
        // @ts-expect-error - Automatic, Please fix when editing this file
        src: (0,_image_url_builder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(image).height(height).width(width).url()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getImageAttributes);


/***/ }),

/***/ 36175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35420);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


/**
 * @param {object} source - Object from Sanity that contains information about the image.
 * @returns {object} Object that can be called with many functions to override behaviour.
 * To override sizing while preserving aspect ratio you can set either height or width to undefined.
 * If you currently have SVG sources, upload a jpg, or just set `.format('jpg')` to test your sizing is reasonable.
 * NOTE: for more detail on the usage of the imageUrlBuilder see https://www.sanity.io/docs/image-url.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var imageUrlBuilder = function(source) {
    return _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default()({
        dataset: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset,
        projectId: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].projectId */ .Z.projectId
    })(source);
};
/* harmony default export */ __webpack_exports__["Z"] = (imageUrlBuilder);


/***/ }),

/***/ 38153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_PLACEHOLDERS_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71439);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46829);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AllPlaceholder {\n    allPlaceholder {\n      _id\n      name\n      identifier {\n        current\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_PLACEHOLDERS_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.gql)(_templateObject());
var useGetAllPlaceholders = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _skip = ref.skip, skip = _skip === void 0 ? false : _skip;
    var ref1 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__.useQuery)(GET_PLACEHOLDERS_QUERY, {
        skip: skip
    }), data = ref1.data, loading = ref1.loading;
    return {
        loading: loading,
        placeholders: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("allPlaceholder", data)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAllPlaceholders);


/***/ }),

/***/ 87902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ award; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/award/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  padding: 0 1rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n    margin-right: 3.75rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    max-width: 40rem;\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-a72238b4-0"
})(_templateObject(), function(props) {
    return props.theme.media.md;
});
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a72238b4-1"
})(_templateObject1(), function(props) {
    return props.theme.media.md;
});
var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a72238b4-2"
})(_templateObject2(), function(props) {
    return props.theme.media.md;
});
var AwardImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-a72238b4-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/award/index.tsx





var Award = function(param) {
    var imageObject = param.imageObject, name = param.name, summaryRaw = param.summaryRaw;
    var image = (0,get_image_attributes/* default */.Z)({
        height: 200,
        imageObject: imageObject
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                variant: [
                    "paddingTopSpacer10",
                    "paddingBottomSpacer10"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardImage, {
                            alt: image.alt,
                            src: image.src
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                looksLike: "h3",
                                variant: [
                                    "simpleBit",
                                    "marginBottomSpacer12"
                                ],
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                source: summaryRaw
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var award = (Award);


/***/ }),

/***/ 60333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var _components_sections_accordion_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64323);
/* harmony import */ var _images_questions_hero_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56940);
/* harmony import */ var _components_sections_wrapped_section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51878);









var CommonQuestions = function(_param) {
    var insuranceType = _param.insuranceType, isTwoColumn = _param.isTwoColumn, title = _param.title, summary = _param.summary, image = _param.image, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "insuranceType",
        "isTwoColumn",
        "title",
        "summary",
        "image"
    ]);
    var accordionId = "".concat(insuranceType, "-insurance-common-questions").concat(isTwoColumn ? "-two-column" : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_wrapped_section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        withWide: isTwoColumn,
        withBorder: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_accordion_section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            accordionId: accordionId,
            initialVisible: _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__.ACCORDION_INITIAL_ITEMS_COUNT,
            image: image || {
                alt: 'Billboard stating "Got questions? We’ve got the answers"',
                src: _images_questions_hero_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src
            },
            isTwoColumn: isTwoColumn,
            title: title || "Common questions",
            withBorder: false,
            summary: summary
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommonQuestions);


/***/ }),

/***/ 76701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contact_details; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/sanity-timezone-placeholder-serializer/index.js
var sanity_timezone_placeholder_serializer = __webpack_require__(72661);
var sanity_timezone_placeholder_serializer_default = /*#__PURE__*/__webpack_require__.n(sanity_timezone_placeholder_serializer);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/contact-details/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding: 0 1rem;\n  @media (min-width: ",
        ") {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 0.25rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-fb31c610-0"
})(_templateObject(), function(props) {
    return props.theme.media.md;
});
var PhoneNumberClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-fb31c610-1"
})(_templateObject1());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fb31c610-2"
})(_templateObject2(), function(param) {
    var isFallbackImage = param.isFallbackImage;
    return isFallbackImage && "\n      img {\n        min-height: 276px;\n      }\n    ";
});

;// CONCATENATED MODULE: ./public/assets/img/call-me.svg
/* harmony default export */ var call_me = ({"src":"/_next/static/media/call-me.0661c97f.svg","height":280,"width":119});
// EXTERNAL MODULE: ./src/client/cms/utils/image-url-builder/index.ts
var image_url_builder = __webpack_require__(36175);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-all-placeholders/index.ts
var use_get_all_placeholders = __webpack_require__(38153);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/contact-details/index.tsx









// @ts-expect-error - Automatic, Please fix when editing this file
var getSubText = function(param) {
    var placeholders = param.placeholders, source = param.source;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
            source: source,
            typeSerializers: {
                placeholder: sanity_timezone_placeholder_serializer_default()({
                    placeholders: placeholders
                })
            }
        }), 
    ];
};
var MEDIUM_SIZE_THRESHOLD = "60rem";
var ROW_LIMIT = 2;
var ContactDetails = function(param) {
    var contact = param.contact, customActionsComponent = param.customActionsComponent, imageObject = param.imageObject, name = param.name, urlObject = param.urlObject;
    var ref, ref1;
    var placeholders = (0,use_get_all_placeholders/* default */.Z)().placeholders;
    var contactInfo = getSubText({
        placeholders: placeholders,
        source: contact.descriptionRaw
    });
    var hasValidUrlObject = (urlObject === null || urlObject === void 0 ? void 0 : urlObject.url) && (urlObject === null || urlObject === void 0 ? void 0 : urlObject.name);
    var hasValidImageObject = Boolean(imageObject === null || imageObject === void 0 ? void 0 : (ref = imageObject.image) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : ref1.url);
    var imageSrc = hasValidImageObject ? (0,image_url_builder/* default */.Z)(imageObject.image.asset).width(undefined).height(500).url() : call_me.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
                variant: [
                    "paddingTopSpacer4",
                    "paddingBottomSpacer4"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* AxisSwitcher */.e$, {
                    limit: ROW_LIMIT,
                    threshold: MEDIUM_SIZE_THRESHOLD,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            isFallbackImage: !hasValidImageObject,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                src: imageSrc
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                    looksLike: "h3",
                                    variant: "marginBottomSpacer10",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H3, {
                                    looksLike: "h4",
                                    variant: "marginBottomSpacer11",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                            name: "phone",
                                            size: "medium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberClickable, {
                                            to: "tel:".concat(contact.phoneNumber),
                                            variant: "unstyleLink",
                                            children: contact.action
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: contactInfo
                                }),
                                hasValidUrlObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                    variant: [
                                        "transparentBlack",
                                        "border"
                                    ],
                                    to: urlObject.url,
                                    children: urlObject.name
                                }) : null,
                                customActionsComponent
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var contact_details = (ContactDetails);


/***/ }),

/***/ 63147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ inclusions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
// EXTERNAL MODULE: ./src/client/pages/insurance/constants/index.ts
var constants = __webpack_require__(19970);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/compare-cover/compare-table/cell/styles.module.sass
var styles_module = __webpack_require__(58869);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/compare-cover/compare-table/cell/index.tsx









var _obj;
var ICON_MAPPING = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED, {
    fill: ahm_ui/* theme.colors.red */.rS.colors.red,
    name: "cross-circle"
}), (0,_define_property/* default */.Z)(_obj, constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED, {
    fill: ahm_ui/* theme.colors.green */.rS.colors.green,
    name: "tick-circle"
}), (0,_define_property/* default */.Z)(_obj, constants/* COVERAGE_INCLUSION.OPTIONAL */.Tb.OPTIONAL, {
    fill: ahm_ui/* theme.colors.blue */.rS.colors.blue,
    name: "plus-circle"
}), _obj);
var _obj1;
var TITLE_MAPPING = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED, "Excluded"), (0,_define_property/* default */.Z)(_obj1, constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED, "Included"), (0,_define_property/* default */.Z)(_obj1, constants/* COVERAGE_INCLUSION.OPTIONAL */.Tb.OPTIONAL, "Optional"), _obj1);
var Cell = function(param) {
    var inclusionType = param.inclusionType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Span */.Dr, {
        className: (styles_module_default()).cell,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ICON_MAPPING[inclusionType]), {
                size: "small"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Span */.Dr, {
                className: (styles_module_default()).label,
                children: [
                    " ",
                    TITLE_MAPPING[inclusionType]
                ]
            })
        ]
    });
};
/* harmony default export */ var cell = (Cell);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/compare-cover/compare-table/styles.module.sass
var compare_table_styles_module = __webpack_require__(43632);
var compare_table_styles_module_default = /*#__PURE__*/__webpack_require__.n(compare_table_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/compare-cover/compare-table/index.tsx








var CompareCoverTable = function(param) {
    var covers = param.covers, features = param.features;
    var columns = [
        {
            colProps: {
                dataVariant: [
                    (compare_table_styles_module_default()).descriptionData,
                    (compare_table_styles_module_default()).cell
                ],
                df: 4,
                sm: 12,
                variant: [
                    (compare_table_styles_module_default()).descriptionHeader,
                    (compare_table_styles_module_default()).headingCell,
                    (compare_table_styles_module_default()).cell
                ]
            },
            header: "Cover",
            key: "title"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)((0,fp.map)(function(param) {
        var name = param.name, id = param.id;
        return {
            colProps: {
                dataVariant: (compare_table_styles_module_default()).cell,
                df: 4,
                sm: 6,
                variant: [
                    (compare_table_styles_module_default()).cell,
                    (compare_table_styles_module_default()).headingCell
                ]
            },
            header: name,
            key: id
        };
    }, covers)));
    var data = (0,fp.map)(function(param) {
        var id = param.id;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var name = (0,fp.find)({
            id: id
        }, features).name;
        var inclusions = (0,fp.map)(function(param) {
            var coverFeatures = param.features, coverId = param.id;
            // @ts-expect-error - Automatic, Please fix when editing this file
            var inclusionState = (0,fp.find)({
                id: id
            }, coverFeatures).inclusionState;
            return (0,_define_property/* default */.Z)({}, coverId, /*#__PURE__*/ (0,jsx_runtime.jsx)(cell, {
                inclusionType: inclusionState
            }));
        }, covers);
        return (0,fp.assignAll)([
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: name
                })
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(inclusions)));
    }, features);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Table */.iA, {
        columns: columns,
        data: data,
        variant: [
            "noHeaderBorder",
            "compact",
            "noBordersMobile",
            (compare_table_styles_module_default()).table
        ]
    });
};
/* harmony default export */ var compare_table = (CompareCoverTable);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/compare-cover/index.tsx




var CompareCover = function(param) {
    var contentTitle = param.contentTitle, covers = param.covers, description = param.description, features = param.features;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                looksLike: "h3",
                children: contentTitle
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(compare_table, {
                covers: covers,
                features: features
            })
        ]
    });
};
/* harmony default export */ var compare_cover = (CompareCover);

// EXTERNAL MODULE: ./src/client/utils/get-footnote-serializer/index.tsx
var get_footnote_serializer = __webpack_require__(50073);
// EXTERNAL MODULE: ./src/client/utils/insert-footnote-reference/index.ts
var insert_footnote_reference = __webpack_require__(74537);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/section/feature-highlight/index.tsx
var feature_highlight = __webpack_require__(67764);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/section/styles.module.sass
var section_styles_module = __webpack_require__(92408);
var section_styles_module_default = /*#__PURE__*/__webpack_require__.n(section_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/section/index.tsx






var TYPE_PROPS = {
    addons: {
        icon: "plus",
        title: "Add ons",
        type: "partial"
    },
    benefits: {
        icon: "tick",
        title: "Additional benefits",
        type: "included"
    },
    inclusions: {
        icon: "tick",
        title: "What’s included",
        type: "included"
    },
    sellingPoints: {
        icon: "tick",
        type: "included"
    }
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getDescriptionComponent = function(param) {
    var description = param.description, isPortableTextDescription = param.isPortableTextDescription;
    return isPortableTextDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: description
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Markdown */.UG, {
        children: description
    });
};
var ItemsSection = function(param) {
    var isPortableTextDescription = param.isPortableTextDescription, items = param.items, type = param.type;
    if ((0,fp.isEmpty)(items)) {
        return null;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    var ref = TYPE_PROPS[type] || {}, title = ref.title, icon = ref.icon, iconType = ref.type;
    var hasSectionTitle = !(0,fp.isEmpty)(title);
    // Render the correct a11y heading for the itemTitle (don't skip heading level)
    var ItemTitleHeading = hasSectionTitle ? ahm_ui.H5 : ahm_ui.H4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
        variant: "marginTopSpacer7",
        children: [
            hasSectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H4, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: (0,fp.map)(function(param) {
                    var callout = param.callout, description = param.description, itemTitle = param.title;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 4,
                        sm: 6,
                        xs: 12,
                        variant: "marginTopSpacer10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* IconLockup */.hp, {
                            icon: {
                                className: (section_styles_module_default()).icon,
                                name: "".concat(icon, "-circle"),
                                size: "small",
                                type: iconType
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTitleHeading, {
                                    looksLike: "h5",
                                    children: [
                                        itemTitle,
                                        callout && [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_highlight/* default */.Z, {
                                                text: callout
                                            }, callout)
                                        ]
                                    ]
                                }),
                                description && getDescriptionComponent({
                                    description: description,
                                    isPortableTextDescription: isPortableTextDescription
                                })
                            ]
                        })
                    }, itemTitle);
                }, items)
            })
        ]
    });
};
/* harmony default export */ var section = (ItemsSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/panel/styles.module.sass
var panel_styles_module = __webpack_require__(31567);
var panel_styles_module_default = /*#__PURE__*/__webpack_require__.n(panel_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/panel/index.tsx







var InclusionsPanel = function(param) {
    var addons = param.addons, benefits = param.benefits, contentTitle = param.contentTitle, cta = param.cta, description = param.description, descriptionFootnote = param.descriptionFootnote, footnote = param.footnote, inclusions = param.inclusions, isPortableTextDescription = param.isPortableTextDescription, sellingPoints = param.sellingPoints;
    var hasCta = (cta === null || cta === void 0 ? void 0 : cta.name) && (cta === null || cta === void 0 ? void 0 : cta.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                    source: (0,insert_footnote_reference/* default */.Z)({
                        footnote: footnote,
                        text: contentTitle
                    }),
                    typeSerializers: (0,get_footnote_serializer/* default */.Z)({
                        footnote: footnote,
                        variant: (panel_styles_module_default()).footnote
                    })
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                source: (0,insert_footnote_reference/* default */.Z)({
                    footnote: descriptionFootnote,
                    text: description
                }),
                typeSerializers: (0,get_footnote_serializer/* default */.Z)({
                    footnote: descriptionFootnote,
                    variant: [
                        (panel_styles_module_default()).footnote,
                        (panel_styles_module_default()).smallFootnote
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section, {
                items: inclusions,
                type: "inclusions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section, {
                items: benefits,
                type: "benefits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section, {
                items: addons,
                type: "addons"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section, {
                items: sellingPoints,
                isPortableTextDescription: isPortableTextDescription,
                type: "sellingPoints"
            }),
            hasCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: [
                    (panel_styles_module_default()).cta,
                    "paddingTopSpacer6"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                    to: cta.url,
                    children: cta.name
                })
            })
        ]
    });
};
/* harmony default export */ var panel = (InclusionsPanel);

// EXTERNAL MODULE: ./src/client/pages/insurance/styles.module.sass
var insurance_styles_module = __webpack_require__(34604);
var insurance_styles_module_default = /*#__PURE__*/__webpack_require__.n(insurance_styles_module);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/styles.module.sass
var inclusions_styles_module = __webpack_require__(73721);
var inclusions_styles_module_default = /*#__PURE__*/__webpack_require__.n(inclusions_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/inclusions/index.tsx











var Inclusions = function(param) {
    var cta = param.cta, footnote = param.footnote, groups = param.groups, title = param.title;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var defaultGroup = (0,fp.size)(groups) > 2 ? groups[1] : (0,fp.head)(groups);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var ref = (0,react.useState)((0,fp.kebabCase)((0,fp.get)("tabTitle", defaultGroup))), value = ref[0], setValue = ref[1];
    if ((0,fp.isEmpty)(groups)) {
        return null;
    }
    var productPanels = (0,fp.map)(function(group) {
        return {
            panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, group), {
                footnote: footnote,
                isPortableTextDescription: true
            }), group.tabTitle),
            text: group.tabTitle,
            value: (0,fp.kebabCase)(group.tabTitle)
        };
    }, (0,fp.reject)({
        id: "compare"
    }, groups));
    var compare = (0,fp.find)({
        id: "compare"
    }, groups);
    var comparisonPanel = compare && {
        panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(compare_cover, (0,_object_spread/* default */.Z)({}, compare)),
        text: compare.tabTitle,
        value: (0,fp.kebabCase)(compare.tabTitle)
    };
    var tabGroupOptions = (0,fp.compact)((0,_to_consumable_array/* default */.Z)(productPanels).concat([
        comparisonPanel
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (insurance_styles_module_default()).horizontalSpacingWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            "paddingTopSpacer3",
                            "paddingBottomSpacer9"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                variant: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                    variant: "marginBottomSpacer4",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TabGroup */.v0, {
                                tabListVariant: (inclusions_styles_module_default()).tabList,
                                input: {
                                    onChange: setValue,
                                    value: value
                                },
                                options: tabGroupOptions
                            })
                        ]
                    }),
                    cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            (inclusions_styles_module_default()).cta,
                            "paddingBottomSpacer8"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                            to: cta.url,
                            children: cta.name
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var inclusions = (Inclusions);


/***/ }),

/***/ 67764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95998);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




var FeatureHighlight = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Span */ .Dr, {
        variant: [
            "simpleBit",
            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().featureHighlight)
        ],
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureHighlight);


/***/ }),

/***/ 37594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_sections_callout_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54996);
/* harmony import */ var _components_sections_features_section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84244);








var ValuePropositions = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _param);
    var tiles = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("tiles", props);
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(tiles)) {
        return null;
    }
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.size)(tiles) > 1) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_features_section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
            withBorder: true
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_callout_section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, tiles[0]), {
        withBorder: true
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ValuePropositions);


/***/ }),

/***/ 19970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ez": function() { return /* binding */ INSURANCE_SUB_TYPES; },
/* harmony export */   "Or": function() { return /* binding */ PRODUCT_REVIEW_IDS; },
/* harmony export */   "Tb": function() { return /* binding */ COVERAGE_INCLUSION; },
/* harmony export */   "oK": function() { return /* binding */ INSURANCE_TYPES; }
/* harmony export */ });
/* unused harmony exports INSURANCE_TYPES_WITH_HEALTH, TRAVEL_PRODUCT_TYPES */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var INSURANCE_TYPES = {
    CAR: "car",
    HOME: "home",
    INCOME_PROTECTION: "income-protection",
    LIFE: "life",
    TRAVEL: "travel"
};
var INSURANCE_TYPES_WITH_HEALTH = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, INSURANCE_TYPES), {
    HEALTH: "health"
});
var INSURANCE_SUB_TYPES = {
    BALI: "bali",
    NEW_ZEALAND: "new-zealand"
};
var COVERAGE_INCLUSION = {
    EXCLUDED: "excluded",
    INCLUDED: "included",
    OPTIONAL: "optional"
};
var PRODUCT_REVIEW_IDS = {
    car: "car",
    home: "home-and-contents"
};
var TRAVEL_PRODUCT_TYPES = {
    DOMESTIC: "domestic",
    INTERNATIONAL: "international"
};


/***/ }),

/***/ 50073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85500);




var onClickFootnote = function(footnoteId) {
    return function() {
        (0,_ui__WEBPACK_IMPORTED_MODULE_3__/* .scrollToElement */ .kI)(document.getElementById(footnoteId));
    };
};
/* eslint-disable react/prop-types */ // @ts-expect-error - Automatic, Please fix when editing this file
var footnoteSerializer = function(footnoteId, variant) {
    return function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
            variant: variant,
            onClick: onClickFootnote(footnoteId),
            children: props.node.text
        });
    };
};
/* eslint-disable react/prop-types */ // @ts-expect-error - Automatic, Please fix when editing this file
var getFootnoteSerializer = function(param) {
    var footnote = param.footnote, variant = param.variant;
    if (footnote) {
        return {
            footnote: footnoteSerializer(footnote.linkId, variant)
        };
    }
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (getFootnoteSerializer);


/***/ }),

/***/ 80365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getFormattedQuestionForAccordion = function(questions) {
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(questions)) {
        return [];
    }
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(item) {
        return {
            analyticsLabel: (item === null || item === void 0 ? void 0 : item.question) && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.kebabCase)(item === null || item === void 0 ? void 0 : item.question),
            body: item === null || item === void 0 ? void 0 : item.answerRaw,
            title: item === null || item === void 0 ? void 0 : item.question
        };
    }, questions);
};
/* harmony default export */ __webpack_exports__["Z"] = (getFormattedQuestionForAccordion);


/***/ }),

/***/ 14033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);
/* harmony import */ var _cms_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


var getShouldSkipClientSideRequest = function() {
    var useLiveFiltering = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].useLiveFiltering */ .Z.useLiveFiltering, asAtDate = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtDate */ .Z.asAtDate, asAtTime = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtTime */ .Z.asAtTime, dataset = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset;
    return !useLiveFiltering || asAtDate === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .NOW */ .Kp && asAtTime === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .MIDDAY */ .T3 && dataset === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATASET.PRODUCTION */ .tz.PRODUCTION;
};
/* harmony default export */ __webpack_exports__["Z"] = (getShouldSkipClientSideRequest);


/***/ }),

/***/ 74537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ FOOTNOTE_PLACEHOLDER; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5398);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64355);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__);



var FOOTNOTE_PLACEHOLDER = "[FOOTNOTE_PLACEHOLDER]";
var insertFootnoteReference = function(param) {
    var text = param.text, footnote = param.footnote;
    var isPortableText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(text) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isPlainObject)(text);
    var textContent = isPortableText ? _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default()(text) : text;
    var splitText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.split)(FOOTNOTE_PLACEHOLDER, textContent);
    return _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1___default()({
        value: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.concat)([
            {
                value: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(splitText)
            },
            footnote && {
                type: "footnote",
                value: footnote.reference
            }
        ], (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(trailingText) {
            return {
                value: trailingText
            };
        }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.tail)(splitText))))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (insertFootnoteReference);


/***/ }),

/***/ 58869:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","cell":"styles_cell__Pb5mF","label":"styles_label__WotlL"};

/***/ }),

/***/ 43632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","headingCell":"styles_headingCell__k6aX6","descriptionHeader":"styles_descriptionHeader__frjh4","descriptionData":"styles_descriptionData__QZ4kT","cell":"styles_cell__iQKx6","table":"styles_table__Jf7Ud"};

/***/ }),

/***/ 31567:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","footnote":"styles_footnote__ca9Z8","smallFootnote":"styles_smallFootnote__nSKet","cta":"styles_cta__yxmN6"};

/***/ }),

/***/ 95998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","featureHighlight":"styles_featureHighlight__JV4cS"};

/***/ }),

/***/ 92408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","icon":"styles_icon__EfS3k"};

/***/ }),

/***/ 73721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","tabList":"styles_tabList__Rf_gH","cta":"styles_cta__XqlXE"};

/***/ }),

/***/ 34604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper____5OI"};

/***/ })

}]);